export default {
  authUser: null,
  authUserData: null
}
